import { render, staticRenderFns } from "./duration.vue?vue&type=template&id=6627ed15&scoped=true"
import script from "./duration.vue?vue&type=script&lang=js"
export * from "./duration.vue?vue&type=script&lang=js"
import style0 from "./duration.vue?vue&type=style&index=0&id=6627ed15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6627ed15",
  null
  
)

export default component.exports